// extracted by mini-css-extract-plugin
export default {"button":"vFALuCJY8EHquWJol12C"};